import { render } from "./SimilarCruises.vue?vue&type=template&id=70fd2412&scoped=true"
import script from "./SimilarCruises.vue?vue&type=script&lang=js"
export * from "./SimilarCruises.vue?vue&type=script&lang=js"

import "./SimilarCruises.vue?vue&type=style&index=0&id=70fd2412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fd2412"]])

export default __exports__